import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
//import { HeaderComponent } from "../../Components";
import GetAllowedRoutes from "../../Routes/allowedRoutes";
import { Routes } from "../../Routes/allRoutes";
import { IReduxState } from "../../utils/types";
import styles from './styles.module.css';
//import logo from '../../Assets/Images/main-logo.png'

const AuthContainer = () => {
    const AuthState = useSelector((state: IReduxState) => state.Auth);
    const redirect = GetAllowedRoutes(Routes)

    //  For Future user
    // const NavigateByRole = () => {
    //     let path = '/'
    //     switch (AuthState?.role) {
    //         case 'admin':
    //             path = '/admin'
    //             break;
    //         case 'user':
    //             path = '/user'
    //             break;
    //         default:
    //             break;
    //     }
    //     return path;
    // }
    return <>
        {AuthState?.user && Object.keys(AuthState.user).length === 0
            ?
            <div className={`${styles.fullback} ${styles.loginPageNewDesign}`}>
                {/* <div className={styles.content_page_header}>
                    <HeaderComponent />
                </div> */}
                <div className="layout_wrapper">
                    {/* <div className={styles.loginwithoutlogo}>
                        <img src={logo} alt='' style={{ width: 40, height: 40 }} />
                    </div> */}
                    <div className="admin_panel_wrp">
                        <div>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            :
            <Navigate to={redirect[0].path === '*' ? '/firstLogin' : redirect[0].path} />}
    </>;
};

export default AuthContainer;